import axios from "axios";
import { API_URL } from "./constant";

export const getRandomAvatar = () => {
    const avatars = [
        "/assets/avatar_one.svg",
        "/assets/avatar_two.svg",
        "/assets/avatar_three.svg",
        "/assets/avatar_four.svg"
    ];
    return avatars[Math.floor(Math.random() * avatars.length)];
};

export const getFirstName = (value) => {
    return value.split(' ')[0];
}

export const getTotalFeed = (amount, isBag=true) => {
    if (isBag) {
        let total_bags = Math.floor(amount / 25);
        let remainder = amount - (total_bags * 25);
        let bag_text = total_bags > 1 ? "Bags" : "Bag";
        let allow_bag = total_bags > 0 ? `${total_bags} ${bag_text}` : '';
        let allow_remainder = remainder > 0 ? `${total_bags > 0 ? ", " : ""}${remainder.toFixed(2)}Kg` : '';

        return `${allow_bag}${allow_remainder}`;
    }
    
    return `${amount} kg`;
}

export const fetchAnimalTypeByCategoryId = async (value, searchParams=null) => {
    let url = `${API_URL}types/${value}`;

    if (searchParams) {
        url = `${url}?${searchParams}`;
    }

    var config = {
        method: 'get',
        url:url,
        headers: {
          'Content-Type': 'application/json'
        }
    };

    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const fetchSpaceCategoryByAnimalTypeId = async (value) => {
    var config = {
        method: 'get',
        url:`${API_URL}space_category/${value}`,
        headers: {
          'Content-Type': 'application/json'
        }
    };

    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const fetchBreedsByAnimalTypeId = async (value) => {
    var config = {
        method: 'get',
        url:`${API_URL}breeds/${value}`,
        headers: {
          'Content-Type': 'application/json'
        }
    };

    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const fetchSubBreedsByAnimalTypeId = async (value) => {
    var config = {
        method: 'get',
        url:`${API_URL}sub_breeds/${value}`,
        headers: {
          'Content-Type': 'application/json'
        }
    };

    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const spaceCalculation = async (token, data) => {
    var config = {
        method: 'get',
        url:`${API_URL}user/calculate/space`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        params:data
    };
    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const feedCalculation = async (token, data) => {
    var config = {
        method: 'get',
        url:`${API_URL}user/calculate/feed`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        params:data
    };
    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const produceCalculation = async (token, data) => {
    var config = {
        method: 'get',
        url:`${API_URL}user/calculate/produce`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        params:data
    };
    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const reviewCalculator = async (token, data) => {
    var config = {
        method: 'post',
        url:`${API_URL}user/create/review`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        params:data
    };
    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const fetchCalculatorReviewByReviewType = async (token, value) => {
    var config = {
        method: 'get',
        url:`${API_URL}user/fetch/review/${value}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
    };

    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const joinWaitlist = async (data) => {
    var config = {
        method: 'post',
        url:`${API_URL}waitlist/add`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
    };

    let resp = await axios(config)
    .then((response) => {
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}


export const NumberFormatter = ({ value }) => {
    const formatNumberWithCommas = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    return <span>{formatNumberWithCommas(value)}</span>;
};